import { handleActions } from "redux-actions";
import { combineReducers } from "redux";
import * as profileFieldsActions from "../actions/profileFieldsActions";

let initState = {};

const customerCompanies = handleActions(
  {
    [profileFieldsActions.getCustomerCompanies]: (state, action) => {
      return {
        ...state,
        isLoading: true
      };
    },
    [profileFieldsActions.getCustomerCompaniesSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        all: payload.data,
        isLoading: false
      };
    },
    [profileFieldsActions.getCustomerCompaniesError]: (state, action) => {
      let { payload } = action;
      console.log("getCustomerCompanies Error", payload.data.message);
      return {
        ...state,
        all: payload.data.message,
        isLoading: false
      };
    },
    [profileFieldsActions.getCustomerCompaniesSearchRequest]: (
      state,
      action
    ) => {
      return {
        ...state,
        value: action.payload,
        isLoading: true
      };
    },
    [profileFieldsActions.getCustomerCompaniesSearchClear]: (state, action) => {
      return {
        ...state,
        value: null,
        search: null,
        isLoading: false
      };
    },
    [profileFieldsActions.getCustomerCompaniesSearchSuccess]: (
      state,
      action
    ) => {
      let { payload } = action;
      return {
        ...state,
        search: payload.data,
        isLoading: false
      };
    },
    [profileFieldsActions.getCustomerCompaniesSearchError]: (state, action) => {
      let { payload } = action;
      console.log("getCustomerCompaniesSearch Error", payload.data.message);
      return {
        ...state,
        search: payload.data.message,
        isLoading: false
      };
    },
    [profileFieldsActions.clearCustomers]: () => initState
  },
  initState
);

const ProfileFields = combineReducers({
  customerCompanies
});

export { ProfileFields };
